import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import type { PortalPromptTextOptions } from '../../../services/portal-dialog.types';

@Component({
  selector: 'app-portal-prompt-dialog',
  templateUrl: './portal-prompt-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalPromptDialogComponent implements OnInit {
  @Input() options: PortalPromptTextOptions = { title: '' };

  busy = false;
  title = '';
  message = '';
  confirmLabel = '';
  cancelLabel = '';
  confirmVariant: 'primary' | 'danger' = 'primary';
  size: 'sm' | 'md' | 'lg' = 'sm';
  inputType: 'text' | 'number' | 'password' | 'email' = 'text';
  inputLabel = '';
  placeholder = '';
  value = '';
  error = '';

  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const o = this.options || { title: '' };
    this.title = o.title || '';
    this.message = o.message || '';
    this.confirmLabel = o.confirmLabel || '';
    this.cancelLabel = o.cancelLabel || '';
    this.confirmVariant = o.confirmVariant === 'danger' ? 'danger' : 'primary';
    this.size = o.size || 'sm';
    this.inputType = o.inputType || 'text';
    this.inputLabel = o.inputLabel || '';
    this.placeholder = o.placeholder || '';
    this.value = o.initialValue != null ? String(o.initialValue) : '';
  }

  dismiss(): void {
    if (this.busy) return;
    this.activeModal.dismiss('cancel');
  }

  onValueChange(next: string): void {
    this.value = next;
    if (this.error) {
      this.error = '';
      this.cdr.markForCheck();
    }
  }

  async submit(): Promise<void> {
    if (this.busy) return;
    const raw = this.value;
    const validator = this.options?.validator;
    if (validator) {
      const msg = validator(raw);
      if (msg) {
        this.error = msg;
        this.cdr.markForCheck();
        return;
      }
    }
    const onConfirm = this.options?.onConfirm;
    if (!onConfirm) {
      this.activeModal.close(raw);
      return;
    }
    this.busy = true;
    this.cdr.markForCheck();
    try {
      await onConfirm(raw);
      this.activeModal.close(raw);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err || '');
      if (message) {
        this.error = message;
      }
    } finally {
      this.busy = false;
      this.cdr.markForCheck();
    }
  }
}
